import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { SubmissionSummaryService } from '../../data-access/services/submission-summary.service'; // updated import

@Component({
  selector: 'app-validationsummary-summary',
  templateUrl: './validationsummary-summary.component.html',
  styleUrls: ['./validationsummary-summary.component.scss'],
  standalone: false,
})
export class ValidationsummarySummaryComponent {
  @Input() currentYear!: number;
  @Input() prfNumber!: string;
  @Input() groupCode!: string;
  validationSummaryItem$;
  validationItems: any[] = [];
  constructor(private readonly submissionSummaryService: SubmissionSummaryService, private readonly router: Router) {}
  ngOnInit(): void {
    this.loadValidationSummaryData();
    this.validationSummaryItem$ = this.submissionSummaryService.selectValidationSummaryData();
  }
  private loadValidationSummaryData() {
    this.submissionSummaryService.loadValidationSummaryData();
  }
  navigateToValidationsummary() {
    this.router.navigate([
      `/${this.currentYear}/${encodeURIComponent(
        this.prfNumber
      )}/validationsummary`,
    ]);
  }
}
